import api from '../modules/api';
import http from '../modules/http';
import { getQueryString } from '../modules/util';
import CONSTANTS from '../constants';


let _timerError = -1;
let _timerMsg = -1;
var actions = {
    setError(error) {
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.SET_ERROR,
                error: true,
                payload: error
            });
            clearTimeout(_timerError);
            _timerError = setTimeout(() => {
                dispatch({
                    type: CONSTANTS.SET_ERROR,
                    error: false,
                    payload: ""
                });
            }, 10000);
        };
    },

    setMsg(msg) {
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.SET_MSG,
                payload: msg
            });
            clearTimeout(_timerMsg);
            _timerMsg = setTimeout(() => {
                dispatch({
                    type: CONSTANTS.SET_MSG,
                    payload: ""
                });
            }, 10000);
        };
    },

    setarSimNao(queId, respSimNao) {
        return {
            type: CONSTANTS.SETAR_SIM_NAO,
            payload: {
                queId, respSimNao
            }
        };
    },

    changeTextoOutros(queId, opcId, opcResOutra) {
        return {
            type: CONSTANTS.CHANGE_TEXTO_OUTROS,
            payload: {
                queId, opcId, opcResOutra
            }
        };

    },

    onChangeGenerico(QueId, payload) {
        // var opcId = payload.opcId;
        // var adrTexto = payload.adrTexto;
        // var adrTextoCurto = payload.adrTextoCurto;
        // var adrComentarios = payload.adrComentarios;

        return {
            type: CONSTANTS.CHANGE_GENERICO,
            payload: {
                QueId,
                ...payload
            }
        };
    },

    getQuestaoCasoPeriodoAtivo() {
        return (dispatch) => {
            dispatch({
                type: CONSTANTS.CARREGAR_QUESTOES.LOADING
            });
            api.getQuestaoCasoPeriodoAtivo().then((response) => {

                dispatch({
                    type: CONSTANTS.CARREGAR_QUESTOES.SUCCESS,
                    payload: {
                        listQuestoes: response.questoes,
                      
                        anjoLogado:  response.anjoLogado
                    }
                });
            }).catch((e) => {
                var err = e || new Error('erro ao carregar questões');
                dispatch(this.setError(err))
                dispatch({
                    type: CONSTANTS.CARREGAR_QUESTOES.ERROR,
                    error: true,
                    payload: err
                });
            });
        };
    },

    gravar() {
        return (dispatch, getState) => {


            let _error = (msg) => {
                var err = new Error(msg);
                dispatch(this.setError(err))
                dispatch({
                    type: CONSTANTS.GRAVAR_RESPOSTAS.ERROR,
                    error: true,
                    payload: err
                });
            };
            var ordem = 0;
            var state = getState().fichaInscricao;
            //validar as perguntas obrigatorias
            let listQuestoes = state.listQuestoes;
            let listRespostas = state.listRespostas;
            if (listQuestoes.some((item, indice) => {
                ordem = indice + 1;
                var resposta = listRespostas[item.QueId];
                if (item.QueIdDependenteSIM) {
                    //se tiver dependente e o dependente não tiver selecionado ===false
                    var respDep = listRespostas[item.QueIdDependenteSIM];
                    if (respDep.RespSimNao === false) {
                        //sai do atual pois o dependente nao ta SIM
                        return false;
                    }
                }
                if (item.QueSimNao && resposta.RespSimNao === void (0)) {
                    return true;
                }
                if (resposta.RespSimNao && (!resposta.ListOpcao || (resposta.ListOpcao && resposta.ListOpcao.length === 0))) {
                    return true;
                }
                return false;
            })) {
                _error('Informe a pergunta ' + ordem);
                return;
            }
            //chegou aqui entao grava
            let listRespostasArray = Object.keys(listRespostas).map((item) => {
                return listRespostas[item];
            });

            dispatch({
                type: CONSTANTS.GRAVAR_RESPOSTAS.LOADING
            });
            api.gravarResposta(listRespostasArray).then((response) => {
                dispatch({
                    type: CONSTANTS.GRAVAR_RESPOSTAS.SUCCESS,
                    payload: {
                        msgOutCadastroAnjo: response.msgOutCadastroAnjo
                    }
                });
            }).catch((err) => {
                _error('Erro: ' + err.message);
            });
        };
    },

    resetSolicitante() {
        return {
            type: CONSTANTS.RESET_SOLICITANTE,
        };
    },

    onChangeGenericoSolicitante(id, valor) {
        return {
            type: CONSTANTS.CHANGE_GENERICO_SOLICITANTE,
            payload: { id, valor }
        };
    },

    changeArea(acao, id) {
        return {
            type: CONSTANTS.CHANGE_AREA,
            payload: {
                acao: acao, //remove,add
                id: id
            }
        };
    },

    getCidadesByUf(tipo, uf) {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_LIST_CIDADES.LOADING
            });
            api.getCidadesByUf(uf).then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES.SUCCESS,
                    payload: {
                        list: response,
                        tipo: tipo
                    }
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar getCidadesByUf");
                dispatch({
                    type: CONSTANTS.CARREGAR_LIST_CIDADES.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    getAreas() {

        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.CARREGAR_AREAS.LOADING
            });
            api.getAreas().then((response) => {
                dispatch({
                    type: CONSTANTS.CARREGAR_AREAS.SUCCESS,
                    payload: response
                });
            }).catch((error) => {
                console.error(error);
                var err = new Error("Erro ao carregar getAreas");
                dispatch({
                    type: CONSTANTS.CARREGAR_AREAS.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });

        };
    },

    getDadosInteressadoCPF(cpf) {

        return (dispatch, getState) => {
            cpf = cpf.replace(/\D/gim, '');
            if (!cpf || cpf.length < 8) {
                return;
            }
            if (cpf.length > 11) {
                return;
            }
            dispatch({
                type: CONSTANTS.GET_PESSOA_DADOS.LOADING
            });
            //caso ja possui solicitacao entao não pode

            api.getPessoasPorCpf(cpf).then((response) => {
                dispatch({
                    type: CONSTANTS.GET_PESSOA_DADOS.SUCCESS,
                    payload: response
                });
                if (response.dadosPessoa) {
                    dispatch(actions.getCidadesByUf('solicitante', response.dadosPessoa.LocUf));
                }
            }).catch((error) => {
                console.error(error);
                var err = (error || new Error("Erro ao carregar cpf"));
                dispatch({
                    type: CONSTANTS.GET_PESSOA_DADOS.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });

        };
    },

    onConsultaCEP(tipo, cep) {
        return (dispatch, getState) => {
            if (cep.length < 8 || cep.length > 9) {
                return;
            }
            dispatch({
                type: CONSTANTS.CONSULTA_CEP.LOADING,
                payload: {
                    tipo
                }
            });
            api.consultaCEP(cep).then((response) => {
                /*
                bairro : "Parque Residencial Servantes"
                cidade : "Presidente Prudente" 
                complemento : "" 
                complemento2 : "" 
                rua : "Rua Isaac Melem" 
                uf : "SP
                */
                response.tipo = tipo;
                dispatch({
                    type: CONSTANTS.CONSULTA_CEP.SUCCESS,
                    payload: response
                });
                if (response.uf) {
                    api.getCidadesByUf(response.uf).then((list) => {
                        var listTemp = list.filter((item) => {
                            return item.loc_nome.trim() === response.cidade.toUpperCase().trim();
                        });
                        if (listTemp.length > 0) {
                            dispatch(this.onChangeGenericoSolicitante(tipo === 'projeto' ? 'locCodProjeto' : 'locCodEndereco', listTemp[0].loc_codigo));
                        }
                        dispatch({
                            type: CONSTANTS.CARREGAR_LIST_CIDADES.SUCCESS,
                            payload: {
                                list: list,
                                tipo: tipo
                            }
                        });
                    });
                }
            }).catch((error) => {
                console.error(error);
                var err = new Error(error.message || "Erro ao carregar CONSULTA_CEP");
                dispatch({
                    type: CONSTANTS.CONSULTA_CEP.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });
        };
    },

    gravarSolicitante() {
        /*
          string solCnpjCpf,
           TipoPessoa solTipo,
           string solNome,
           string solDtnascimentoStr,
           string solEmail,
           string solFone,
           string solBairro,
           string solEndereco,
           string solCep,
           string solTituloProjeto,
           string solDescricaoProje,
           string solCepProjeto,
           string solBairroProjeto,
           string solLocalProjeto,
           string solAcoes,
           int solQtdVoluntario,
           string solBeneficio,
           int solOrigem,
           string solDtinicioStr,
           string solDtfimStr,
           HttpPostedFile ArquivoAnexo,
           int locCodEndereco,
           int locCodProjeto,
           List<int> listAreas
        
        */

        return (dispatch, getState) => {
            let solicitante = getState().solicitante;

            console.log(solicitante);
            var error = "";
            var campos = {
                "solTipo": "",
                "solUF": "",
                "solUFProjeto": "",
                "listAreasSelecionadas": "",
                "solOrigem": "",
                "solCnpjCpf": "",
                "solNome": "",
                //  "solDtnascimento": "",
                "solFone": "",
                "solEmail": "",
                "solCep": "",
                "solBairro": "",
                "solEndereco": "",
                "locCodEndereco": "",
                "solTituloProjeto": "",
                //"solCepProjeto": "",
                //  "solBairroProjeto": "",
                //  "solLocalProjeto": "",
                // "locCodProjeto": "",
                "solDescricaoProje": "",
                "solAcoes": "",
                "solQtdVoluntario": "",
                "solBeneficio": "",
                "solDtinicio": "",
                "solDtfim": "",
            };

            var camposCondicionalTipoPessoa = {};
            if (solicitante.solTipo == 'J'.charCodeAt(0).toString()) {
                camposCondicionalTipoPessoa = {
                    "solContato": ""
                };

            } else {
                camposCondicionalTipoPessoa = {
                    "solDtnascimento": ""
                };
            }
            campos = {...campos, ...camposCondicionalTipoPessoa};
            for (var c in campos) {
                if (!solicitante[c]) {
                    error = true;
                    break;
                }
            }
            if (error) {
                var err = new Error('Informe todos os campos');
                dispatch({
                    type: CONSTANTS.GRAVAR_SOLICITANTE.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
                return;
            }


            dispatch({
                type: CONSTANTS.GRAVAR_SOLICITANTE.LOADING
            });
            api.gravarSolicitante(solicitante).then((response) => {
                dispatch({
                    type: CONSTANTS.GRAVAR_SOLICITANTE.SUCCESS
                });
                dispatch(actions.setMsg("Sua solicitação foi recebida e será avaliada pela Pró-Reitoria de Extensão e Ação Comunitária da Unoeste (PROEXT). Logo entraremos em contato."));
                dispatch(actions.resetSolicitante());

            }).catch((error) => {
                var err = new Error(error.message || "Erro GRAVAR_SOLICITANTE");
                dispatch({
                    type: CONSTANTS.GRAVAR_SOLICITANTE.ERROR,
                    error: true,
                    payload: err
                });
                dispatch(actions.setError(err));
            });


        };

    },

    verificaSeCadastroVoluntarioEstaLiberado() {
        return (dispatch, getState) => {
            dispatch({
                type: CONSTANTS.VERIFICA_LIBERACAO.LOADING
            });
            api.verificaSeCadastroVoluntarioEstaLiberado().then((response) => {
                if (response.liberado) {
                    dispatch({
                        type: CONSTANTS.VERIFICA_LIBERACAO.SUCCESS,
                        payload: response
                    });
                } else {
                    throw new Error(response.msg || 'Cadastro não liberado ');
                }
            }).catch((error) => {

                dispatch({
                    type: CONSTANTS.VERIFICA_LIBERACAO.ERROR,
                    error: true,
                    payload: error
                });
                dispatch(actions.setError(error));
            });

        };
    }
};

export default actions;